import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import './../../css/Default.css'

const Loader = props => (
  <div className={props.classes.root} style={props.style}>
    <div className='loader'> </div>
  </div>
)

const styles = theme => ({
  root: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

export default withStyles(styles)(Loader)